import React, {Component} from "react";

import Input from "./Input";

import imgClose from "../../../resources/img/svgicons/close3.svg";
import imgSearch from "../../../resources/img/svgicons/search.svg";

/**
 * @class SearchInput
 *
 * Predefined search input with search/erase SVG and input field
 *
 * [Confluence page]{@link https://deso.atlassian.net/wiki/spaces/Redlike/pages/144670729/SearchInput}
 *
 * @param {string} [value] - current value
 * @param {string} [size] - input size
 * @param {string} [className] - className to be passed to Input element
 * @param {function} [onChange] - function called on input change
 * @param {function} [resetFilterClick] - called on svg click
 * @param {boolean} [inFront] - specifies if svg is in front or after input
 *
 * @example
 *  <SearchInput
 *      className="primary-input"
 *      resetFilterClick={this.handleClearInputClick}
 *      onChange={this.handleCustomFandecksSearchInputChange}
 *      value={this.state.searchInput}
 *  />
 *
 */
export default class SearchInput extends Component {
    render() {
        return (
            <Input
                className={this.props.className}
                size={this.props.size}
                svgAfter={this.props.value === "" || !this.props.resetFilterClick ? imgSearch : imgClose}
                svgAfterAction={this.props.value === "" ? undefined : this.props.resetFilterClick}
                onChange={this.props.onChange}
                value={this.props.value}
            />
        );
    }
}
